// convert number to usd
export const usd = (value, noZero) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: noZero ? 0 : 2,
  }).format(value);
};

export const usdNoEndingZeroes = (value, isUpsellSub) => {
  if (value % 1 === 0 || isUpsellSub) {
    return usd(value, true);
  }
  return usd(value, false);
};
